import axios from "axios";
import _ from 'lodash';
import Vue from 'vue';

const successNotification = (message) => {
  Vue.notify({
    group: 'admin:account:details',
    title: '',
    text: message,
    type: 'success',
    duration: 3000,
    speed: 500
  });
};

export default {
	namespaced: true,
	state: {
    roleTitles: [],

		teams: [],

		internalUsers: [],

		resources: [],
	},
	mutations: {

		setTeamData(state, team) {
            //console.log('setting htis team', team)
			state.teams = team;
		},

		setResources (state, resources) {
			state.resources = resources;
		},

		setInternalUsers(state, team_members) {
       //console.log('setting htis team', team)
			state.internalUsers = team_members;
		},

		/**
		 * Update the sort order of teams in the store state.
		 *
		 * @param {Object} state
		 * @param {Object} payload
		 */
		updateTeamSortOrder(state, payload) {
			// Update the sort order of the teams
			state.teams = payload.teams;
		},

		/**
		 * Update the notify setting of a team member in state.
		 *
		 * @param {Object} state
		 * @param {Object} payload
		 */
		updateTeamNotifySetting(state, payload) {
			// Update the notify setting of the team with the given ID
			const teamIndex = state.teams.findIndex((team) => team.team_id === payload.teamId);

			state.teams[teamIndex].notify = payload.notify;
		},

		/**
		 * Update the visibility setting of a team member in state
		 *
		 * @param {Object} state
		 * @param {Object} payload
		 */
		updateTeamVisibility(state, payload) {
			// Update the notify setting of the team with the given ID
			const teamIndex = state.teams.findIndex((team) => team.team_id === payload.teamId);

			state.teams[teamIndex].visible = payload.visible;
		},

		/**
		 * Update the title of a team member in state.
		 *
		 * @param {Object} state
		 * @param {Object} payload
		 */
		updateTeamTitle(state, payload) {
			// Update the title of the team with the given ID
			const teamIndex = state.teams.findIndex((team) => team.team_id === payload.id);

			state.teams[teamIndex].title = payload.title;
		},

		/**
		 * Add a team member to the state.
		 *
		 * @param {Object} state
		 * @param {Object} payload
		 */
		addTeamMember(state, payload) {
			// Delete the team with the given ID
			if (!payload.team_id) return console.error('no team member given', payload);

			state.teams.push(payload);
		},

		/**
		 * Delete a team from the state.
		 *
		 * @param {Object} state
		 * @param {Object} payload
		 */
		deleteTeam(state, payload) {
			// Delete the team with the given ID
			state.teams = state.teams.filter((team) => team.team_id !== payload.team_id);
		},

		/**
		 * Update the name of a team in state.
		 *
		 * @param {Object} state
		 * @param {Object} payload
		 */
		updateTeamName(state, payload) {
			// Update the name of the team with the given ID
			const teamIndex = state.teams.findIndex((team) => team.id === payload.id);

			state.teams[teamIndex].name = payload.name;
		},
	},

	actions: {

        /**
         *
         * @param {Object} context
         * @param {String|Integer} accountId
         * @returns {Promise<void>}
         */
        async loadTeamData (context, accountId) {

            try {
                const response = await axios.get(`/admin/account-details/teams/${accountId}`);

                context.commit('setTeamData', response.data.team);

                return response.data.team;
            } catch ($e) {
                //handle error
            }
        },

		/**
		 * Update the order of teams.
		 *
		 * @param {Object} context
		 * @param {Object} payload
		 * @return {Promise}
		 */
        sort(context, payload) {
			//sort the teams and return the array
		},

		/**
		 * Update the notify setting of a team member
		 *
		 * @param {Object} context
		 * @param {Object} payload
		 * @return {Promise}
		 */
		async updateNotify(context, payload) {
			try {
        const {teamId, notify} = payload;

				// Update the notify setting of the team on the server
				const response = await axios.post(`/admin/account-details/teams/update-notify/${teamId}`, {notify});

				// Commit a mutation to update the notify setting of the team in the store state
				context.commit('updateTeamNotifySetting', {
					teamId: teamId,
					notify: response.data.notify,
				});

				successNotification(`Notifications now ${notify ? 'visible' : 'hidden'} ${notify ? 'to' : 'from'} this user`);

				return response.data;
			} catch (error) {
				// Handle the error
			}
		},



		/**
		 * Update the title of a team member
		 *
		 * @param {Object} context
		 * @param {Object} payload
		 * @return {Promise}
		 */
		async updateTitle(context, payload) {
			try {
                const {teamId, title} = payload;

				// Update the title of the team on the server
				const response = await axios.post(`/admin/account-details/teams/update-title/${teamId}`, {title});

                let responseTitle = response.data.title;

                console.log('response', responseTitle)

				// Commit a mutation to update the title of the team in the store state
				context.commit('updateTeamTitle', {
					id: teamId,
					title: responseTitle,
				});

				successNotification('Users Title settings updated');

				return response.data;
			} catch (error) {
				// Handle the error
				console.error('update title error:', error);
			}
		},


		/**
		 * Create an empty team title
		 *
		 * @param {Object} context
		 * @param {Object} payload
		 * @return {Promise}
		 */
		async addTeamMemberTitle(context, payload) {
			try {
          const {accountId, title, user_id} = payload;

					// Update the title of the team on the server
					const response = await axios.post(`/admin/account-details/teams/create-title/${accountId}`, {title, user_id});

	        let teamMember = response.data.team_member;

					// Commit a mutation to update the title of the team in the store state
					context.commit('addTeamMember', teamMember);

					successNotification(`Added ${teamMember.firstname} ${teamMember.lastname} to your team as '${teamMember.title}'`);

					return teamMember;
				} catch (error) {
					// Handle the error
					console.error('update title error:', error);
				}
		},

		/**
		 * Delete a team meber
		 *
		 * @param {Object} context
		 * @param {Object} payload
		 * @return {Promise}
		 */
		async delete(context, payload) {
			try {
        const {team_id} = payload;

				// Delete the team on the server
				const response = await axios.delete(`/admin/account-details/teams/delete-member/${team_id}`);

				// Commit a mutation to delete the team from the store state
				if (response.data == 'success') {
					context.commit('deleteTeam', {
						team_id
					});

					successNotification('Team Member was deleted!');
				}

				return response.data;
			} catch (error) {
				// Handle the error
				console.error('delete team member error:', error);
			}
		},

		/**
		 * Update the name of a team member
		 *
		 * @param {Object} context
		 * @param {Object} payload
		 * @return {Promise}
		 */
		async updateName(context, payload) {
			try {
        const {name, userId} = payload;

				// Update the name of the team on the server
				const response = await axios.post(`/admin/account-details/teams/update-name/${userId}`, {name});

				// Commit a mutation to update the name of the team in the store state
				context.commit('updateTeamName', {
					id: payload.id,
					name: response.data.name,
				});

				return response.data;
			} catch (error) {
				// Handle the error
			}
		},

		/**
		 * Update the visibility of a team member
		 *
		 * @param {Object} context
		 * @param {Object} payload
		 * @return {Promise}
		 */
		async updateVisibility(context, payload) {
			try {
        const {teamId, visible} = payload;

				// Update the visibility of the team on the server
				const response = await axios.post(`/admin/account-details/teams/update-visibility/${teamId}`, {visible});

				// Commit a mutation to update the visibility of the team in the store state
				context.commit('updateTeamVisibility', {
					teamId: teamId,
					visible: visible,
				});

				successNotification(`User now ${visible ? 'visible' : 'hidden'} ${visible ? 'to' : 'from'} client`);

				return response.data;
			} catch (error) {
				// Handle the error
			}
		},

		/**
		 * Get Acclaro Resources
		 *
		 * @param {Object} context
		 * @param {Object} payload
		 * @return {Promise}
		 */
		async getResources (context, payload) {
			try {
        const response = await axios.get(`/admin/account-details/teams/resources/list`);

        context.commit('setResources', response.data.resources);

        return response.data.resources;
      } catch ($e) {
      	console.error('getResources:', $e);
        //handle error
      }
		},

		/**
		 * Get a list of internal users
		 *
		 * @param {Object} context
		 * @param {Object} payload
		 * @return {Promise}
		 */
		async getInternalUsers (context, payload) {
			try {
        const response = await axios.get(`/admin/account-details/teams/internal-members/list`);

        context.commit('setInternalUsers', response.data.team_members);

        return response.data.team_members;
      } catch ($e) {
      	console.error('getInternalUsers:', $e);
        //handle error
      }
		},
	},
	getters: {
		/**
		 * Get all teams sorted by priority.
		 *
		 * @param {Object} state
		 * @return {Array}
		 */
		sortedTeams(state) {
      //console.log('teamsstate', state.teams)
      if (!state.teams) return [];

			return state.teams.sort((a, b) => a.lastname.localeCompare(b.lastname));
		},

		/**
		 * Get internal team members
		 *
		 * @param {Object} state
		 * @return {Array}
		 */
		internalUsers(state) {
      //console.log('teamsstate', state.teams)
      if (!state.internalUsers) return [];

			return state.internalUsers.sort((a, b) => (a.firstname ?? '').localeCompare(b.firstname ?? ''));
		},

		/**
		 * Get resources
		 *
		 * @param {Object} state
		 * @return {Array}
		 */
		resources(state) {
      //console.log('teamsstate', state.teams)
      if (!state.resources) return [];

			return state.resources.sort((a, b) => (a.firstname ?? '').localeCompare(b.firstname ?? ''));
		},

		/**
		 * Get the team with the given ID.
		 *
		 * @param {Object} state
		 * @param {Number} id
		 * @return {Object|null}
		 */
		teamById(state, id) {
			return state.teams.find((team) => team.id === id) || null;
		},

        /**
         * get team titles
         */
        teamTitles (state) {
          return _.union(
						['Supervisor', 'Project Manager', 'QA'],
						state.teams.map(member => member.title)
					).filter(Boolean);
        },
    }
};
